// extracted by mini-css-extract-plugin
module.exports = {"ChatDealListPane":"ChatDealListPane_ChatDealListPane__sGe0j","Title":"ChatDealListPane_Title__05WlL"};